
import { Create, Edit, Form, TextInput, Toolbar } from "react-admin"
import { MailBatchQueryJsonInput } from './MailBatchQueryJsonInput';
import { Card, CardContent } from '@mui/material';


const MailBatchForm = () => {
    return (
        <Card>
            <CardContent>
                <TextInput source="name" required />
                <TextInput source="description" />
                <TextInput source="template" />
                <MailBatchQueryJsonInput source="query" />
            </CardContent>
            <Toolbar />
        </Card>
    )
}

export const MailBatchEdit = () =>
    <Edit>
        <Form sanitizeEmptyValues>
            <MailBatchForm />
        </Form>
    </Edit>


export const MailBatchCreate = () =>
    <Create>
        <Form sanitizeEmptyValues>
            <MailBatchForm />
        </Form>
    </Create>
